/*
 * Copyright (c) 2022. Haodong JU
 */

import { loadBaseConfig } from 'aaden-base-model/lib/Models/GlobalSettings'
import { LocalSettingManager } from 'biewangle'
import i18n from './i18n'

const defaultConfig = require('@/assets/config.json')

export let NeededKeys = []
const GlobalConfig = Object.assign({
  isShowOnTable: localStorage.getItem('isShowOnTable') || '0',
  UseDailyZbon: localStorage.getItem('UseDailyZbon') || '0',
}, defaultConfig)

export const GlobalConfigLang = LocalSettingManager.config({
  lang: 'zh',
  useTimelineView: 0,
  currentUserId: '',
})

export async function loadConfig (overwrite) {
  Object.assign(GlobalConfig, await loadBaseConfig(Object.assign(GlobalConfig, overwrite)))
  NeededKeys = GlobalConfig.neededKeys
  window.Config = GlobalConfig

  // console.log('GlobalConfig base', GlobalConfig)
}

export function changeLanguage (lang) {
  const l = lang.toLowerCase()
  const backServerLang = ['de', 'zh', 'en']
  localStorage.setItem('frontEndLang', l)
  if (backServerLang.includes(l)) {
    GlobalConfig.updateSettings('lang', l)
  } else {
    GlobalConfig.updateSettings('lang', 'de')
  }
  i18n.locale = l

  window.location.reload(true)
}

export function isRestaurant () {
  return Remember.restaurantVersion
}

export const Remember = LocalSettingManager.config({
  showGraph: false,
  onlyCharged: true,
  restaurantVersion: 1,
  readAgHint: false,
  readItemHint: false,
  showStorageManagement: 0,
})
export default GlobalConfig
